import {
  Typography,
  styled,
  Button,
  Dialog,
  Box,
  IconButton,
} from '@mui/material';

export const OutlinedButton = styled(Button)(({ theme }) => ({
  maxWidth: '140px',
  height: '40px',
  border: `1.5px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: '#FAFCFF',
  textTransform: 'lowercase',
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
  },
  '&:disabled': {
    color: theme.palette.secondary.main,
  },
}));

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    maxWidth: '1000px',
    borderRadius: 16,
    backgroundColor: '#FAFCFF',
  },
}));

export const DialogContainer = styled(Box)(() => ({
  minWidth: 1000,
  minHeight: 200,
  padding: '40px 40px',
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
}));

export const TextTypography = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignContent: 'center',
  span: {
    color: theme.palette.secondary.main,
  },
}));

export const CloseButtonBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row-reverse',
}));

export const CloseIcon = styled(IconButton)(({ theme }) => ({
  margin: '20px 20px -50px 0',
  '& span': {
    fontSize: '24px',
    fontWeight: '600',
    color: theme.palette.secondary.main,
  },
}));
